.group {
  display: grid;
  min-width: 0;
  gap: 1rem;

  &[data-columns="2"] {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  &[data-columns="3"] {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  &[data-columns="4"] {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  &[data-columns="auto"] {
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 13rem), 1fr));
  }

  &[data-variant="summary"] {
    gap: 0;
    padding: 1.25rem 1.5rem;
    background: var(--color-card);
  }

  &[data-variant="summary"] > .item {
    padding: 0.25rem 1.5rem;
  }

  &[data-variant="summary"] > .item:first-child {
    padding-inline-start: 0;
  }

  &[data-variant="summary"] > .item:last-child {
    padding-inline-end: 0;
  }

  &[data-variant="summary"][data-divided="true"] > .item + .item {
    border-inline-start: 1px solid var(--color-border);
  }

  &[data-variant="rows"] {
    gap: 0;
    container-type: inline-size;

    > .item {
      padding: 0.625rem 0;
    }

    > .item + .item {
      border-top: 1px solid var(--color-border);
    }

    .definition {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
      align-items: baseline;
      gap: 0.5rem 1rem;
    }

    .label {
      overflow-wrap: anywhere;
    }
  }
}

@container (max-width: 22rem) {
  .group[data-variant="rows"] .definition {
    grid-template-columns: minmax(0, 1fr);
  }
}

.item {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 0.75rem;

  &[data-span="full"] {
    grid-column: 1 / -1;
  }
}

.withIcon {
  grid-template-columns: 2.5rem minmax(0, 1fr);
  align-items: center;
}

.withAction {
  grid-template-columns: minmax(0, 1fr) auto;
}

.withIcon.withAction {
  grid-template-columns: 2.5rem minmax(0, 1fr) auto;
}

.definition {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.35rem;
  margin: 0;
}

.label {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.375rem;
  color: var(--color-muted);
}

.content {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
  color: var(--color-foreground);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
}

.action {
  align-self: center;
}

@media (max-width: 760px) {
  .group[data-columns]:not([data-columns="1"]) {
    grid-template-columns: 1fr;
  }

  .group[data-variant="summary"] > .item {
    padding: 0.9rem 0;
  }

  .group[data-variant="summary"][data-divided="true"] > .item + .item {
    border-top: 1px solid var(--color-border);
    border-inline-start: 0;
  }
}
